import React from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';

interface AlertSnackbarProps {
  open: boolean;
  message: string;
  severity: AlertColor;
  handleClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
}

const AlertSnackbar: React.FC<AlertSnackbarProps> = ({ open, message, severity, handleClose }) => (
  <Snackbar
    open={open}
    autoHideDuration={severity === 'error' || severity === 'warning' ? 9000 : 3000}
    onClose={handleClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  >
    <Alert
      onClose={handleClose}
      severity={severity}
      sx={{
        width: '100%',
        maxWidth: 640,
        alignItems: 'flex-start',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default AlertSnackbar;
